<template>
  <section :class="computedClasses">
    <TContainer
      :size="containerSize"
      class="space-y-10 md:space-y-16"
    >
      <template v-if="layout === 'one-column'">
        <div class="space-y-4">
          <slot name="pre-title">
            <TMarketingPreTitle v-if="preTitle">
              {{ preTitle }}
            </TMarketingPreTitle>
          </slot>

          <THeadingMarketing
            :level="3"
            tag="h2"
          >
            <slot name="title">
              {{ title }}
            </slot>
          </THeadingMarketing>

          <p
            v-if="subTitle"
            :class="computedSubtitleClasses"
          >
            {{ subTitle }}
          </p>
        </div>

        <slot />

        <slot name="cta" />
      </template>

      <template v-else-if="layout === 'two-columns'">
        <div class="grid gap-8 lg:grid-cols-2 lg:gap-16">
          <div class="space-y-4">
            <slot name="pre-title">
              <TMarketingPreTitle v-if="preTitle">
                {{ preTitle }}
              </TMarketingPreTitle>
            </slot>

            <THeadingMarketing
              :level="3"
              tag="h2"
            >
              <slot name="title">
                {{ title }}
              </slot>
            </THeadingMarketing>

            <p
              v-if="subTitle"
              :class="computedSubtitleClasses"
            >
              {{ subTitle }}
            </p>

            <slot />

            <slot name="cta" />
          </div>

          <div>
            <slot name="secondary" />
          </div>
        </div>
      </template>
    </TContainer>
  </section>
</template>

<script setup lang="ts">
import type { ContainerSize } from '~/components/_tailwind/container/types'

const props = withDefaults(defineProps<{
  preTitle?: string
  title?: string
  subTitle?: string
  variant?: 'dark' | 'default' | 'light' | 'muted'
  layout?: 'one-column' | 'two-columns'
  containerSize?: ContainerSize
}>(), {
  variant: 'default',
  layout: 'one-column',
})

const computedClasses = computed(() => [
  'py-18 md:py-20 lg:py-24',
  { 'bg-white': props.variant === 'default' },
  { 'bg-primary-50': props.variant === 'light' },
  { 'bg-primary-950 text-white': props.variant === 'dark' },
  { 'bg-gray-50': props.variant === 'muted' },

  { 'text-center': props.layout === 'one-column' },
  { 'text-left': props.layout === 'two-columns' },
])

const computedSubtitleClasses = computed(() => [
  'max-w-4xl mx-auto',
  { 'text-white/75': props.variant === 'dark' },
  { 'text-gray-500': props.variant !== 'dark' },
])
</script>
